import { useTheme } from "@modernatx-internal/component-library";
import React from "react";

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(false); // Default to false for SSR
  const theme = useTheme();

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= parseInt(theme.breakpoints[1], 10));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [theme.breakpoints]);

  return isMobile;
};
